import { emitter } from 'shared/helpers/mitt';
import { conversationListPageURL } from './URLHelper';

// After "mark unread": leave the open chat so markMessagesRead cannot undo it.
// Do NOT switch/persist the "Não lidas" quick filter: that made every inbox
// list re-filter the shared cache to unread_count > 0 until the chip changed.
export const openUnreadConversationList = (
  router,
  { accountId, inboxId, label, teamId } = {}
) => {
  emitter.emit('fetch_conversation_stats');
  router.push(
    conversationListPageURL({
      accountId,
      inboxId,
      label,
      teamId,
    })
  );
};
